import { RouterProvider } from '@tanstack/react-router';

import * as TanStackQueryProvider from './integrations/tanstack-query/root-provider.tsx';
import { router } from '@/router/router.tsx';
import { TooltipProvider } from '@/components/ui/tooltip.tsx';
import { useEffect } from 'react';
import { navigationHelper } from '@/router/navigationHelper.ts';

export default function App() {
  useEffect(() => {
    navigationHelper.navigate = router.navigate;
    return () => {
      navigationHelper.navigate = null;
    };
  }, [router.navigate]);
  return (
    <TanStackQueryProvider.Provider>
      <TooltipProvider>
        <RouterProvider router={router} />
      </TooltipProvider>
    </TanStackQueryProvider.Provider>
  );
}
